<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>停车管理</el-breadcrumb-item>
            <el-breadcrumb-item>车辆管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center;justify-content:space-between;width:100%">
              <div style="display:flex;align-items:center;margin-right:20px;width:55%;justify-content:space-between;">      
                 <el-select
                   v-model="logout"
                   clearable
                   filterable
                   placeholder="请选择状态"
                   class="select"
                   @change="search"
                   style="width:200px"
                 >
                   <el-option  v-for="item in stutas" :key="item.value" :label="item.name" :value="item.value"></el-option>
                 </el-select>
                <el-input v-model="carNumber" placeholder="请输入车牌号" style="width:200px" @input="doFilter" clearable>
                  <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
                   <el-button
                     v-if="isMenuExit('pro:car:select')"
                     type="primary"
                     @click="attendVisible = true"
                   >选择车库</el-button>
                     <el-button
                     v-if="isMenuExit('pro:car:add')"
                     type="primary"
                     @click="addCar"
                   >添加车辆</el-button>
              </div>
              <div style="display:flex;align-items:center;width:15%;justify-content:space-between;">     
                <!-- <el-button
                  type="primary"      
                  size="mini"
                  style="display:flex;align-items:center"
                  @click="exportInfo()"
                >导出</el-button> -->
                 <el-tooltip class="item" effect="dark" content="导出" placement="top-end" v-if="isMenuExit('pro:car:export')">
                    <img  @click="exportInfo" class="icon_hover" src="../../assets/image/export.png" alt="" srcset="">
                </el-tooltip>
                <el-upload
                  v-if="isMenuExit('pro:car:import')"
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="uploadHead"
                  :show-file-list="false"
                  :on-success="handleAppSuccess"
                  :data="uploadData"
                >
                  <!-- <el-button type="success" size="mini" icon="el-icon-upload">导入</el-button> -->
                    <el-tooltip class="item" effect="dark" content="导入" placement="top-end">
                    <img  class="icon_hover" src="../../assets/image/import.png" alt="" srcset="">
                </el-tooltip>
                </el-upload>
              </div>
            </div>
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table
              stripe
              :data="tableData"
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
                @selection-change="handleSelectionChange"
            >
             <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
          <el-table-column label="编号">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="车牌号">
            <template slot-scope="scope">
              <span>{{scope.row.carNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column label="车牌类型">
            <template slot-scope="scope">
              <span>{{ scope.row.carType }}</span>
            </template>
          </el-table-column>
          <el-table-column label="车辆类型">
            <template slot-scope="scope">
              <span>{{ scope.row.vehicleCategoryName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="车辆司机">
            <template slot-scope="scope">
              <span>{{scope.row.personName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机号">
            <template slot-scope="scope">
              <span>{{scope.row.phone}}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期" width='200'>
            <template slot-scope="scope">
              <span>{{scope.row.endTime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="登记时间" width='200'>
            <template slot-scope="scope">
              <span>{{scope.row.starTime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="行驶证">
            <template slot-scope="scope">
              <el-image v-if="scope.row.photo!=''" style="width: 5vh; height: 5vh;cursor: pointer;" :src="scope.row.photo" :preview-src-list="scope.row.srcList"></el-image>
              <img v-else src="../../assets/image/zanwutupian.png" style="width: 5vh; height: 5vh;cursor: pointer;" />
            </template>
          </el-table-column>
          <el-table-column label="所属车库" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div v-if="scope.row.logout==0" class="minibtn">
                <el-button type="text" size="mini" @click="editFun(scope.row)" v-if="isMenuExit('pro:car:edit')">编辑</el-button>
                <el-button type="text" size="mini" @click="logOut(scope.row.carId)" v-if="isMenuExit('pro:car:cancel')">注销</el-button>
              </div>
              <div  v-if="scope.row.logout==1" class="minibtn">
                <el-button type="text" size="mini" @click="editFun(scope.row)" v-if="isMenuExit('pro:car:edit')">编辑</el-button>
                <el-button type="text" style="color:#C4C4C4" size="mini" @click="editFun(scope.row)" v-if="isMenuExit('pro:car:edit')">已注销</el-button>
              </div>
              <span
                v-if="scope.row.logout==2"
                style="color:#1BD095"
                @click="wait(scope.row)"
                class="hand"
              >待审核</span>
              <span v-if="scope.row.logout==3" style="color:#f00">未通过</span>
            </template>
          </el-table-column>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100, 500, 1000]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
              <!-- 编辑窗口 -->
          <el-dialog
            :title="dialogTitle"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :before-close="handleClose"
            :lock-scroll="false"
            width="30%"
          >
            <el-form
              :model="editForm"
              ref="editForm"
              label-width="150px"
              :label-position="labelPosition"
               :rules="rules"
            > 
              <!-- <el-form-item label="班组人员">         
                 <el-select
                   v-model="editForm.personId"
                   clearable
                   filterable
                   placeholder="请选择状态"
                   class="select"
                   v-if="editForm.id==''"
                   style="width:220px"
                 >
                   <el-option  v-for="item in perlists" :key="item.personId" :label="item.label" :value="item.personId"></el-option>
                 </el-select>
                 <span v-else>{{editForm.personName}}</span>
              </el-form-item> -->
              <!-- <el-form-item label="车主:">
                <el-input
                  v-model="editForm.personName"
                  autocomplete="off"
                  style="width:220px"
                ></el-input>
              </el-form-item> -->
             <el-form-item label="车辆司机:" prop="name">
                <el-input
                  v-model="editForm.name "
                  autocomplete="off"
                  style="width:220px"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号:" prop="phone" v-if="editForm.id==''">
                <el-input
                  v-model="editForm.phone "
                  autocomplete="off"
                  style="width:220px"
                ></el-input>
              </el-form-item>
                 <el-form-item label="手机号:" prop="phone" v-else>
                <el-input
                  v-model="editForm.phone "
                  autocomplete="off"
                  style="width:220px"
                  readonly
                ></el-input>
              </el-form-item>
              <el-form-item label="车牌类型:">
                 <el-select
                   v-model="editForm.carType"
                   clearable
                   filterable
                   placeholder="请选择状态"
                   class="select"    
                   style="width:220px"
                 >
                   <el-option  v-for="item in carTypes" :key="item.type" :label="item.label" :value="item.value"></el-option>
                 </el-select>
              </el-form-item>
              <!-- <el-form-item label="车辆类型:">
                <el-select
                  v-model="editForm.vehicleCategory"
                  clearable
                  filterable
                  placeholder="请选择状态"
                  class="select"    
                  style="width:220px"
                >
                  <el-option  v-for="item in plateTypes" :key="item.type" :label="item.label" :value="item.value"></el-option>
                </el-select>
             </el-form-item> -->
              <el-form-item label="车牌号:">
                <el-input
                  v-model="editForm.carNumber "
                  autocomplete="off"
                  style="width:220px"
                ></el-input>
              </el-form-item>
              <el-form-item label="行驶证:">
                <el-upload
                  class="avatar-uploader"
                  v-bind:action="uploadUrl1"
                  :headers="uploadHead1"
                  :data="{type:224}"
                  :show-file-list="false"
                  :on-success="handleIconSuccess"
                >
                  <img v-if="icon" :src="icon" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <!-- <el-form-item label="手机号:">
                <el-input
                  v-model="editForm.phone "
                  type="phone"
                  autocomplete="off"
                  style="width:220px"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="开始时间:"  prop="starTime">
                <!-- <el-date-picker
                  v-model="editForm.endTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>-->
                <el-date-picker
                  v-model="editForm.starTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期时间"
                  default-time="12:00:00"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="有效时间:"  prop="endTime">
                <!-- <el-date-picker
                  v-model="editForm.endTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>-->
                <el-date-picker
                  v-model="editForm.endTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="选择日期时间"
                  default-time="12:00:00"
                ></el-date-picker>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="editFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow('editForm')">确 定</el-button>
            </div>
          </el-dialog>
           <!-- 审核 -->
          <!-- <el-dialog
            :title="dialogTitle"
            :visible.sync="waitFormVisible1"
            center
            :append-to-body="true"
            :before-close="handleClose1"
            :lock-scroll="false"
            width="30%"
          >
            <el-form
              :model="waitForm"
              ref="waitForm"
              label-width="100px"
              :label-position="labelPosition"
            >
              <el-form-item label="车主:">
                <el-input v-model="waitForm.personName" autocomplete="off" style="width:220px"></el-input>
              </el-form-item>
              <el-form-item label="车牌类型:">
                <el-input v-model="waitForm.carType " autocomplete="off" style="width:220px"></el-input>
              </el-form-item>
              <el-form-item label="行驶证:">
                <img :src="icon" class="avatar" />
              </el-form-item>
              <el-form-item label="有效期:">
                <el-date-picker
                  v-model="waitForm.endTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width:220px"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="登记时间:">
                <el-date-picker
                  v-model="waitForm.starTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  disabled
                  style="width:220px"
                ></el-date-picker>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="argeeNot('waitForm')">不同意</el-button>
              <el-button type="primary" @click="argee('waitForm')">同 意</el-button>
            </div>
          </el-dialog> -->
           <!-- 批量下发 -->
          <el-dialog
            title="选择移入的车库"
            :visible.sync="attendVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
          >
            <el-select
              v-model="carport"
              clearable
              filterable
              placeholder="请选择车库"
              class="select"
              @change="changeCarport"
            >
              <el-option v-for="item in cars" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
              <el-button @click="attendVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAttend()">确 定</el-button>
            </div>
          </el-dialog>
           <!-- 导入成功 -->
          <el-dialog
            :title="dialogTitle1"
            :visible.sync="imoportVisible"
            center
            :append-to-body="true"
            :before-close="handleClose2"
            :lock-scroll="false"
            width="30%"
          >   
            <template>
              <el-table :data="tableData1" style="width: 100%" border>
                <el-table-column label="状态" >
                  <template slot-scope="scope">
                    <span v-if="scope.row.status==0">
                      <i class="el-icon-circle-check" style="color:#07C160"></i>
                    </span>
                    <span v-if="scope.row.status==1">
                      <i class="el-icon-warning-outline" style="color:#f00"></i>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="reason" label="原因">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status==0" style="color:#07C160">{{scope.row.reason}}</span>
                    <span v-if="scope.row.status==1" style="color:#f00">{{scope.row.reason}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-dialog>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
     var checkphone = (rule, value, callback) => {
        // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
            if (value == '') {
                callback(new Error('请输入手机号'))
            } else if (!this.isCellPhone(value)) {
                //引入methods中封装的检查手机格式的方法
                callback(new Error('请输入正确的手机号!'))
            } else {
                callback()
            }
        }
    return {
      labelPosition:'right',
      tableData: [], //获取数据
      tableData1: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectId: '',
      serchName: '', //车库名称
      uploadUrl: myHttp.importLicenseForExcel, //上传地址
      uploadHead: {
        accessToken: util.session.get('token')
      },
      uploadData: {
        projectId: ''
      },
      dataText: '暂无数据',
      uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
      uploadHead1: {
        accessToken: util.session.get('token')
      },
      dialogTitle1: '导入',
      editFormVisible: false,
      waitFormVisible1: false,
      waitForm: {
        personId: '',
        personName: '',
        carType: '',
         drivingCarPhoto: ' ',
        id: ' ',
        starTime: '',
        endTime: ''
      },
      dialogTitle: '',
      editForm: {
        // personId: '',
        name:'',
        phone:'',
        id: '',
        carType: '',
        starTime: '',
        endTime: '',
        plateType:''
        // phone: ''
      },
      icon: '', // 行驶证图
      updateBy: '',
      userId: '',
      stutas: [
        { value: '0', name: '有效' },
        { value: '1', name: '无效' },
      ],
      logout: '',
      carNumber: '',
      multipleSelection: [],
      attendVisible: false,
      imoportVisible: false,
      attendData: [],
      attendData1: [],
      licenseIds: '', //车牌id
      cars: [],
      carport: '', //车库id
      carTypes:[],//车牌类型
      plateTypes:[],//车辆类型
      perlists:[],//人员信息列表
       rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, validator: checkphone, trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择有效期', trigger: 'blur' }],
        starTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
      }
    }
  },
  mounted() {
    this.projectId = util.session.get('groupId')
    this.userId = util.session.get('user').id
    this.updateBy = util.session.get('user').id
    if (this.projectId == '') {
      this.$store.commit('setGroupId')
      this.projectId = this.$store.state.groupId
    }
    ;(this.uploadData.projectId = this.projectId), this.getData()
    // this.getList()
    // console.log(this.$store.state.token)
    this.getCar()
    this.getCarType()
    this.getPersonId()
    this.getplateType()
  },
  methods: {
    //获取数据
    getData() {
      var that = this
      myHttp
        .secCarNumberByProjectId({
          projectId: this.projectId,
          carNumber: this.carNumber,
          logout: this.logout,
          pageSize: this.pageSize,
          pageNum: this.currentPage
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              // console.log(resp)
              var list = resp.data.data.licenses.list || []
              for (var i = 0; i < list.length; i++) {
                list[i].index = that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
                list[i].photo = list[i].drivingPermit && list[i].drivingPermit!=''?base.httpCtx+list[i].drivingPermit:''
                list[i].srcList = list[i].photo && list[i].photo!=''?[list[i].photo]:[]
                // if (list[i].name.indexOf(',') != -1) {
                //   list[i].name1 = list[i].name1
                // } else {
                //   list[i].name1 = list[i].name.split(',')
                //   console.log(list[i].name1)
                // }
              }
              that.tableData = list
              that.totalItems = resp.data.data.licenses.total
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    addCar(){
      this.dialogTitle="添加车辆"
      this.editFormVisible=true
       this.editForm = {
        // personId:'',
        phone:'',
        name:'',
        personName:'',
        carType: '',
        carNumber:'',
        id: '',
        endTime:'',
        starTime:''
      }
      this.icon = ''
    },
    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.editForm.projectId = this.projectId
     
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(that.editForm.id==''){
           myHttp.createInfoCarId(that.editForm).then(
            function(resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.editFormVisible = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function() {}
          )
          }else{
          myHttp.updateEndDate(that.editForm).then(
            function(resp) {
              if (resp.data.code == '200') {
                that.$message.success('修改成功')
                that.editFormVisible = false
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function() {}
          )
          }
        }
      })
    },

    argee(formName) {
      console.log(formName)
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.waitForm.logout = 4
          myHttp
            .updateInfoNumber({
              logout: 4,
              id: that.waitForm.id,
              star: that.waitForm.starTime,
              end: that.waitForm.endTime,
              projectId: this.projectId
            })
            .then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success(resp.data.msg)
                  that.waitFormVisible1 = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
        }
      })
    },
    argeeNot(formName) {
      // console.log(formName)
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          myHttp
            .updateInfoNumber({
              logout: 3,
              id: that.waitForm.id,
              star: that.waitForm.starTime,
              end: that.waitForm.endTime,
              projectId: this.projectId
            })
            .then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success(resp.data.msg)
                  that.waitFormVisible1 = false
                  that.getData()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 编辑弹框
    editFun(row) {
      this.dialogTitle = '修改车牌'
      this.editFormVisible = true
      this.editForm = {
        // personId: row.personId,
        phone:row.phone,
        name:row.personName,
        personName: row.personName,
        carType: row.value,
        carNumber:row.carNumber,
        id: row.carId,
        endTime:row.endTime,
        phone: row.phone,
        vehicleCategory:row.vehicleCategory,
        starTime:row.starTime
      }
       this.icon =row.drivingPermit && row.drivingPermit != '' ? base.httpCtx + row.drivingPermit: ''
    },
  
    // 注销
    logOut(id) {
      var that = this
      this.$confirm('此操作将永久注销该车牌, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          myHttp
            .logoutCar({
              projectId: this.projectId,
              id: id
            })
            .then(function(resp) {
              if (resp.data.code == '200') {
                that.$message({
                  type: 'success',
                  message: '注销成功!'
                })
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch(err => {})
    },
    // 导出
    exportInfo() {
      var token = this.$store.state.token
      window.open(
        myHttp.exportLicenseForExcel +
          '?projectId=' +
          this.projectId +
          '&carNumber=' +
          this.carNumber +
          '&logOut=' +
          this.logout +
          '&accessToken=' +
          token
      )
    },
    doFilter() {
      this.getData()
    },
    //
    handleChange(e) {
      this.editForm.useType = e.value
      // console.log(e.value)
    },

    //上传成功监听方法
    handleAppSuccess(res, file) {
      if (res.code == '200') {
        this.imoportVisible = true
        this.tableData1 = res.data.list
        this.getData()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 上传图片
    handleIconSuccess(res, file) {
      this.icon = URL.createObjectURL(file.raw)
      this.editForm.drivingCarPhoto = res.data.savePhotoUrls
    },
    // 查询
    search() {
      this.getData()
    },
    // 关闭弹出框弹窗
    handleClose(done) {
      this.editFormVisible = false
    },
    handleClose1(done) {
      this.waitFormVisible1 = false
    },
    handleClose2(done) {
      this.imoportVisible = false
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      for (var i = 0; i < this.multipleSelection.length; i++) {
        if (i == 0) {
          this.licenseIds = this.multipleSelection[i].carId
        } else {
          this.licenseIds += ',' + this.multipleSelection[i].carId
        }
        console.log(this.licenseIds)
      }
    },
    // 弹出框列表
    getList() {
      var that = this
      myHttp
        .secCarportAndCamera({
          projectId: this.projectId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.carportInfo || []
              that.attendData = list
              for (var i = 0; i < list.length; i++) {
                // list[i].direction = list[i].direction == 1 ? '进闸' : '出闸'
                list[i].index = parseInt(i + 1)
              }
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    // 获取车库列表
    getCar() {
      var that = this
      myHttp
        .secCarportByLikeNameList({
          projectId: this.projectId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              that.cars = resp.data.data.carports || []
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    //更改车库
    changeCarport() {},
    // 选择车库
    sumbitAttend() {
      if (this.multipleSelection.length == '0') {
        this.$message({
          type: 'warning',
          message: '请选择需要选择的车牌号!'
        })
        return
      }
      var that = this
      myHttp
        .createInfocarInfo({
          licenseId: this.licenseIds,
          carportId: this.carport
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              that.$message.success(resp.data.msg)
              that.attendVisible = false
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    // 待审核和审核未通过
    selectable(row) {
      // console.log(row)
      if (row.logout == '1') {
        return false
      } else {
        return true
      }
    }, 
    /**车牌类型 */
    getCarType(){
       var that = this
        myHttp.getDictByType({
          type:'plate_type'
        }).then(function(resp){
          if(resp.data.code=='200'){
            var list = resp.data.data.dictList||[]  
            console.log(list) 
            that.carTypes = list
          }
        })
    },
    /**车辆类型 */
    getplateType(){
       var that = this
        myHttp.getDictByType({
          type:'vehicle_category'
        }).then(function(resp){
          if(resp.data.code=='200'){
            var list = resp.data.data.dictList||[]
            console.log(list)
            that.plateTypes = list
          }
        })
    },
    /**获取人员列表 */
    getPersonId(){
        var that = this
        myHttp.secZzPerson({
          projectId:this.projectId
        }).then(function(resp){
          if(resp.data.code=='200'){
            var list = resp.data.data.list||[]
             for(var i=0;i<list.length;i++){
              list[i].label = list[i].name +'('+list[i].phone+')'
            }
            that.perlists = list
          }
        })
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },
     //检查手机号
        isCellPhone(val) {
            if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
                return false
            } else {
                return true
            }
        },
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
  overflow: auto;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px 10px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 127px);
  width: 98%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.cur {
  background: #ecf5ff !important;
  /* border: 1px solid   #409EFF !important ; */
  color: #409eff !important  ;
}
div >>> .el-dialog--center .el-dialog__body {
  text-align: center !important;
}

.avatar{
  width: 100%;
}
.content >>>.el-input-group--append .el-input__inner{
      width: 150px;
    }
</style>